import { Resolve, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Transporter } from '../../../models/transporter.model';
import { CurrentDataService } from '../../../services/current-data-service';

@Injectable({ providedIn: 'root' })
export class CurrentTransporterResolver implements Resolve<Transporter> {
  constructor(private currentDataService: CurrentDataService, private router: Router) {}

  public resolve(): Observable<Transporter> | Observable<never> {
    return this.currentDataService.getCurrentTransporter().pipe(
      mergeMap((transporter: Transporter | undefined) => {
        if (transporter) {
          return of(transporter);
        } else {
          this.router.navigate(['404']);
          return EMPTY;
        }
      })
    );
  }
}
